import httpClient from './_httpClient';
import httpClientWithoutToken from "./_httpClientWithoutToken";

const END_POINT = '/users';

const addToken = (token, grant_type = 'token', expiredToken = null) => {
  let data = {
    token: token,
    grant_type: grant_type
  };
  if (expiredToken !== null) {
    data.expired_token = expiredToken
  }
  return httpClientWithoutToken.post("token", data)
};
const getMe = () => httpClient.get("/me");
const logAs = (userId) => httpClient.get("/logAs/" + userId);
const updateMyLanguage = (language) => httpClient.put(END_POINT+ "/languages", language);
const updateSms = (myData) => httpClient.put(END_POINT + "/sms", myData);
const getUsersNames = (paginated = true) => {
  let params = {
    select: "fullName"
  };
  if (!paginated) {
    params.paginated = false;
  }
  return httpClient.get(END_POINT, {params});
}

const getUsersRoleScopes = () => httpClient.get(END_POINT);
const assignUsersRoleScopes = (id, userData) => httpClient.put(END_POINT+'/role/scopes/'+ id, userData);
const logSignOut = () => httpClient.post("/sign-out");
const addUserByAdmin = (userData) => httpClient.post(END_POINT, userData);
const resendSignUpInvitationEmail = (userId) => httpClient.get(END_POINT + "/" + userId + "/resend-signup-invitation");
const resendResetingPasswordEmail = (userId) => httpClient.get(END_POINT + "/" + userId + "/resend-reseting-password");
const signUp = (userData, token) => httpClientWithoutToken.post(END_POINT + "/signup", userData, {params: {token_hint: token}});
const verifySignUpToken = (token) => httpClientWithoutToken.get(END_POINT + "/verify-signup-token/" + token);
const resendSignUpInvitationEmailByUser = (token) => httpClientWithoutToken.get(END_POINT + "/renew-signup-token/" + token);

const exportUsers = (params,config) => httpClient.get("/exportUsers"+params,config);
const getUser = (userId) => httpClient.get(END_POINT + "/" + userId);
const updateUserName = (userId, data) => httpClient.put(END_POINT + "/update-user-name/" + userId, data);
const updateUserNavIdInScope = (userId, scopeId, data) => httpClient.put(END_POINT + "/update-user-nav-id/" + userId + '/' + scopeId, data);

const getVendorsByScope = (scopeId, data) => httpClient.get('getVendorsByScope/' + scopeId, {params: data});
const updateUserVendorId = (userId, data) => httpClient.put('/users/update-user-vendor-id/' + userId, data);

const deleteUser = (userId) => httpClient.delete(END_POINT + "/" + userId);
const enableOrDisableUser = (userId) => httpClient.put(END_POINT + "/enableOrDisableUser/" + userId);

const getUserLastActions = (userId, data) => httpClient.get(END_POINT + "/" + userId + '/last-actions', {params: data});
const getUserLastNotifications = (userId, data) => httpClient.get(END_POINT + "/" + userId + '/last-notifications', {params: data});

export {
  addToken,
  getMe,
  updateMyLanguage,
  getUsersNames,
  getUsersRoleScopes,
  assignUsersRoleScopes,
  logAs,
  logSignOut,
  addUserByAdmin,
  resendSignUpInvitationEmail,
  signUp,
  verifySignUpToken,
  resendSignUpInvitationEmailByUser,
  updateSms,
  exportUsers,
  getUser,
  updateUserName,
  updateUserNavIdInScope,
  getVendorsByScope,
  updateUserVendorId,
  deleteUser,
  enableOrDisableUser,
  getUserLastActions,
  getUserLastNotifications,
  resendResetingPasswordEmail
}
